import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const RiskBannerRatingContainer = styled('div')(({ theme }) => ({
  width: '100%',
  textAlign: 'center',

  span: {
    color: theme.palette.grey400.main,
  },
}));

export const RiskBannerSectionText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'mainSection',
})(({ theme, mainSection }) => ({
  paddingTop: mainSection ? theme.spacing(2) : 0,
}));

export const RiskBannerLockIconSet = styled('span')(({ theme }) => ({
  'img:first-of-type': {
    marginRight: theme.spacing(1),
  },
}));

export const RiskBannerContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasTerminationSection',
})(({ theme, hasTerminationSection }) => ({
  maxWidth: 600,
  margin: theme.spacing(4, 0),
  background: theme.palette.white.main,
  border: `1px solid ${theme.palette.cream100.main}`,
  borderRadius: 8,
  outline: 'none',
  [theme.breakpoints.up('md')]: {
    '> :nth-child(2)': {
      borderRight: hasTerminationSection ? `1px solid ${theme.palette.cream100.main}` : 0,
    },
  },
  [theme.breakpoints.up('sm')]: {
    display: 'grid',
    gridTemplateColumns: hasTerminationSection ? '1fr 1fr 1fr' : '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    '> :nth-child(2)': {
      borderRight: 0,
      borderBottom: hasTerminationSection ? `1px solid ${theme.palette.cream100.main}` : 0,
    },
  },
}));

export const RiskBannerMainSection = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    borderRight: `1px solid ${theme.palette.cream100.main}`,
  },
  [theme.breakpoints.down('sm')]: {
    borderBottom: `1px solid ${theme.palette.cream100.main}`,
  },
}));

export const RiskBannerSection = styled('div', {
  shouldForwardProp: (prop) => prop !== 'earlyTerminationSection',
})(({ theme, earlyTerminationSection }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: earlyTerminationSection ? theme.spacing(6) : theme.spacing(8),
  padding: theme.spacing(4),
}));
